export const Schedule = () => {
    return {
        "request": {
            "lang": "en",
            "currency": "USD",
            "time": 3,
            "id": "5b8ey826ufk",
            "server": "e",
            "host": "airlabs.co",
            "pid": 1572671,
            "key": {
                "id": 26278,
                "api_key": "df50f1d0-6ff7-4d2a-9b63-427e4ddaa583",
                "type": "free",
                "expired": "2023-09-11T22:00:00.000Z",
                "registered": "2023-08-13T14:42:14.000Z",
                "limits_by_hour": 2500,
                "limits_by_minute": 250,
                "limits_by_month": 1000,
                "limits_total": 940
            },
            "params": {
                "dep_iata": "MIA",
                "lang": "en"
            },
            "version": 9,
            "method": "schedules",
            "client": {
                "ip": "101.0.63.72",
                "geo": {
                    "country_code": "IN",
                    "country": "India",
                    "continent": "Asia",
                    "city": "Bengaluru",
                    "lat": 12.9634,
                    "lng": 77.5855,
                    "timezone": "Asia/Kolkata"
                },
                "connection": {
                    "type": "cable/dsl",
                    "isp_code": 23682,
                    "isp_name": "Broadband Pacenet Pvt. Ltd"
                },
                "device": {},
                "agent": {},
                "karma": {
                    "is_blocked": false,
                    "is_crawler": false,
                    "is_bot": false,
                    "is_friend": false,
                    "is_regular": true
                }
            }
        },
        "response": [
            {
                "airline_iata": "GB",
                "airline_icao": "ABX",
                "flight_iata": "GB901",
                "flight_icao": "ABX901",
                "flight_number": "901",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": null,
                "dep_gate": null,
                "dep_time": "2023-08-16 09:20",
                "dep_time_utc": "2023-08-16 13:20",
                "dep_estimated": "2023-08-16 08:50",
                "dep_estimated_utc": "2023-08-16 12:50",
                "dep_actual": "2023-08-16 08:50",
                "dep_actual_utc": "2023-08-16 12:50",
                "arr_iata": "PTY",
                "arr_icao": "MPTO",
                "arr_terminal": null,
                "arr_gate": null,
                "arr_baggage": null,
                "arr_time": "2023-08-16 11:24",
                "arr_time_utc": "2023-08-16 16:24",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "active",
                "duration": 184,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": "B763",
                "arr_time_ts": 1692203040,
                "dep_time_ts": 1692192000,
                "dep_estimated_ts": 1692190200,
                "dep_actual_ts": 1692190200
            },
            {
                "airline_iata": "5Y",
                "airline_icao": "GTI",
                "flight_iata": "5Y3822",
                "flight_icao": "GTI3822",
                "flight_number": "3822",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": null,
                "dep_gate": null,
                "dep_time": "2023-08-16 04:48",
                "dep_time_utc": "2023-08-16 08:48",
                "dep_estimated": "2023-08-16 09:19",
                "dep_estimated_utc": "2023-08-16 13:19",
                "dep_actual": "2023-08-16 09:19",
                "dep_actual_utc": "2023-08-16 13:19",
                "arr_iata": "CVG",
                "arr_icao": "KCVG",
                "arr_terminal": null,
                "arr_gate": null,
                "arr_baggage": null,
                "arr_time": "2023-08-16 11:32",
                "arr_time_utc": "2023-08-16 15:32",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "active",
                "duration": 404,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": "B763",
                "arr_time_ts": 1692199920,
                "dep_time_ts": 1692175680,
                "dep_estimated_ts": 1692191940,
                "dep_actual_ts": 1692191940
            },
            {
                "airline_iata": "AA",
                "airline_icao": "AAL",
                "flight_iata": "AA1447",
                "flight_icao": "AAL1447",
                "flight_number": "1447",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D20",
                "dep_time": "2023-08-16 09:29",
                "dep_time_utc": "2023-08-16 13:29",
                "dep_estimated": "2023-08-16 09:20",
                "dep_estimated_utc": "2023-08-16 13:20",
                "dep_actual": "2023-08-16 09:20",
                "dep_actual_utc": "2023-08-16 13:20",
                "arr_iata": "HAV",
                "arr_icao": "MUHA",
                "arr_terminal": "3",
                "arr_gate": "B11",
                "arr_baggage": null,
                "arr_time": "2023-08-16 10:45",
                "arr_time_utc": "2023-08-16 14:45",
                "arr_estimated": "2023-08-16 10:34",
                "arr_estimated_utc": "2023-08-16 14:34",
                "arr_actual": "2023-08-16 10:34",
                "arr_actual_utc": "2023-08-16 14:34",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "landed",
                "duration": 76,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692197100,
                "dep_time_ts": 1692192540,
                "arr_estimated_ts": 1692196440,
                "dep_estimated_ts": 1692192000,
                "arr_actual_ts": 1692196440,
                "dep_actual_ts": 1692192000
            },
            {
                "airline_iata": "AA",
                "airline_icao": "AAL",
                "flight_iata": "AA1869",
                "flight_icao": "AAL1869",
                "flight_number": "1869",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D12",
                "dep_time": "2023-08-16 09:24",
                "dep_time_utc": "2023-08-16 13:24",
                "dep_estimated": "2023-08-16 09:20",
                "dep_estimated_utc": "2023-08-16 13:20",
                "dep_actual": "2023-08-16 09:20",
                "dep_actual_utc": "2023-08-16 13:20",
                "arr_iata": "GYE",
                "arr_icao": "SEGU",
                "arr_terminal": null,
                "arr_gate": null,
                "arr_baggage": null,
                "arr_time": "2023-08-16 12:48",
                "arr_time_utc": "2023-08-16 17:48",
                "arr_estimated": "2023-08-16 12:35",
                "arr_estimated_utc": "2023-08-16 17:35",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "active",
                "duration": 264,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": "B38M",
                "arr_time_ts": 1692208080,
                "dep_time_ts": 1692192240,
                "arr_estimated_ts": 1692207300,
                "dep_estimated_ts": 1692192000,
                "dep_actual_ts": 1692192000
            },
            {
                "airline_iata": "BA",
                "airline_icao": "BAW",
                "flight_iata": "BA4999",
                "flight_icao": "BAW4999",
                "flight_number": "4999",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D48",
                "dep_time": "2023-08-16 09:20",
                "dep_time_utc": "2023-08-16 13:20",
                "dep_estimated": "2023-08-16 09:22",
                "dep_estimated_utc": "2023-08-16 13:22",
                "dep_actual": "2023-08-16 09:22",
                "dep_actual_utc": "2023-08-16 13:22",
                "arr_iata": "PHL",
                "arr_icao": "KPHL",
                "arr_terminal": "B",
                "arr_gate": "B7",
                "arr_baggage": "15",
                "arr_time": "2023-08-16 12:07",
                "arr_time_utc": "2023-08-16 16:07",
                "arr_estimated": "2023-08-16 12:00",
                "arr_estimated_utc": "2023-08-16 16:00",
                "cs_airline_iata": "AA",
                "cs_flight_number": "1623",
                "cs_flight_iata": "AA1623",
                "status": "active",
                "duration": 167,
                "delayed": null,
                "dep_delayed": 2,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692202020,
                "dep_time_ts": 1692192000,
                "arr_estimated_ts": 1692201600,
                "dep_estimated_ts": 1692192120,
                "dep_actual_ts": 1692192120
            },
            {
                "airline_iata": "IB",
                "airline_icao": "IBE",
                "flight_iata": "IB4925",
                "flight_icao": "IBE4925",
                "flight_number": "4925",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D48",
                "dep_time": "2023-08-16 09:20",
                "dep_time_utc": "2023-08-16 13:20",
                "dep_estimated": "2023-08-16 09:22",
                "dep_estimated_utc": "2023-08-16 13:22",
                "dep_actual": "2023-08-16 09:22",
                "dep_actual_utc": "2023-08-16 13:22",
                "arr_iata": "PHL",
                "arr_icao": "KPHL",
                "arr_terminal": "B",
                "arr_gate": "B7",
                "arr_baggage": "15",
                "arr_time": "2023-08-16 12:07",
                "arr_time_utc": "2023-08-16 16:07",
                "arr_estimated": "2023-08-16 12:00",
                "arr_estimated_utc": "2023-08-16 16:00",
                "cs_airline_iata": "AA",
                "cs_flight_number": "1623",
                "cs_flight_iata": "AA1623",
                "status": "active",
                "duration": 167,
                "delayed": null,
                "dep_delayed": 2,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692202020,
                "dep_time_ts": 1692192000,
                "arr_estimated_ts": 1692201600,
                "dep_estimated_ts": 1692192120,
                "dep_actual_ts": 1692192120
            },
            {
                "airline_iata": "G3",
                "airline_icao": "GLO",
                "flight_iata": "G36203",
                "flight_icao": "GLO6203",
                "flight_number": "6203",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D48",
                "dep_time": "2023-08-16 09:20",
                "dep_time_utc": "2023-08-16 13:20",
                "dep_estimated": "2023-08-16 09:22",
                "dep_estimated_utc": "2023-08-16 13:22",
                "dep_actual": "2023-08-16 09:22",
                "dep_actual_utc": "2023-08-16 13:22",
                "arr_iata": "PHL",
                "arr_icao": "KPHL",
                "arr_terminal": "B",
                "arr_gate": "B7",
                "arr_baggage": "15",
                "arr_time": "2023-08-16 12:07",
                "arr_time_utc": "2023-08-16 16:07",
                "arr_estimated": "2023-08-16 12:00",
                "arr_estimated_utc": "2023-08-16 16:00",
                "cs_airline_iata": "AA",
                "cs_flight_number": "1623",
                "cs_flight_iata": "AA1623",
                "status": "active",
                "duration": 167,
                "delayed": null,
                "dep_delayed": 2,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692202020,
                "dep_time_ts": 1692192000,
                "arr_estimated_ts": 1692201600,
                "dep_estimated_ts": 1692192120,
                "dep_actual_ts": 1692192120
            },
            {
                "airline_iata": "EI",
                "airline_icao": "EIN",
                "flight_iata": "EI7270",
                "flight_icao": "EIN7270",
                "flight_number": "7270",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D48",
                "dep_time": "2023-08-16 09:20",
                "dep_time_utc": "2023-08-16 13:20",
                "dep_estimated": "2023-08-16 09:22",
                "dep_estimated_utc": "2023-08-16 13:22",
                "dep_actual": "2023-08-16 09:22",
                "dep_actual_utc": "2023-08-16 13:22",
                "arr_iata": "PHL",
                "arr_icao": "KPHL",
                "arr_terminal": "B",
                "arr_gate": "B7",
                "arr_baggage": "15",
                "arr_time": "2023-08-16 12:07",
                "arr_time_utc": "2023-08-16 16:07",
                "arr_estimated": "2023-08-16 12:00",
                "arr_estimated_utc": "2023-08-16 16:00",
                "cs_airline_iata": "AA",
                "cs_flight_number": "1623",
                "cs_flight_iata": "AA1623",
                "status": "active",
                "duration": 167,
                "delayed": null,
                "dep_delayed": 2,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692202020,
                "dep_time_ts": 1692192000,
                "arr_estimated_ts": 1692201600,
                "dep_estimated_ts": 1692192120,
                "dep_actual_ts": 1692192120
            },
            {
                "airline_iata": "H8",
                "airline_icao": "SKX",
                "flight_iata": "H85591",
                "flight_icao": "SKX5591",
                "flight_number": "5591",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "C",
                "dep_gate": "F3",
                "dep_time": "2023-08-16 09:30",
                "dep_time_utc": "2023-08-16 13:30",
                "dep_estimated": "2023-08-16 09:22",
                "dep_estimated_utc": "2023-08-16 13:22",
                "dep_actual": "2023-08-16 09:22",
                "dep_actual_utc": "2023-08-16 13:22",
                "arr_iata": "LIM",
                "arr_icao": "SPJC",
                "arr_terminal": null,
                "arr_gate": null,
                "arr_baggage": null,
                "arr_time": "2023-08-16 14:30",
                "arr_time_utc": "2023-08-16 19:30",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "active",
                "duration": 360,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": "A20N",
                "arr_time_ts": 1692214200,
                "dep_time_ts": 1692192600,
                "dep_estimated_ts": 1692192120,
                "dep_actual_ts": 1692192120
            },
            {
                "airline_iata": "AA",
                "airline_icao": "AAL",
                "flight_iata": "AA1623",
                "flight_icao": "AAL1623",
                "flight_number": "1623",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D48",
                "dep_time": "2023-08-16 09:20",
                "dep_time_utc": "2023-08-16 13:20",
                "dep_estimated": "2023-08-16 09:22",
                "dep_estimated_utc": "2023-08-16 13:22",
                "dep_actual": "2023-08-16 09:22",
                "dep_actual_utc": "2023-08-16 13:22",
                "arr_iata": "PHL",
                "arr_icao": "KPHL",
                "arr_terminal": "B",
                "arr_gate": "B7",
                "arr_baggage": "15",
                "arr_time": "2023-08-16 12:07",
                "arr_time_utc": "2023-08-16 16:07",
                "arr_estimated": "2023-08-16 12:00",
                "arr_estimated_utc": "2023-08-16 16:00",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "active",
                "duration": 167,
                "delayed": null,
                "dep_delayed": 2,
                "arr_delayed": null,
                "aircraft_icao": "A21N",
                "arr_time_ts": 1692202020,
                "dep_time_ts": 1692192000,
                "arr_estimated_ts": 1692201600,
                "dep_estimated_ts": 1692192120,
                "dep_actual_ts": 1692192120
            },
            {
                "airline_iata": "BA",
                "airline_icao": "BAW",
                "flight_iata": "BA4929",
                "flight_icao": "BAW4929",
                "flight_number": "4929",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "C",
                "dep_gate": "E9",
                "dep_time": "2023-08-16 09:30",
                "dep_time_utc": "2023-08-16 13:30",
                "dep_estimated": "2023-08-16 09:23",
                "dep_estimated_utc": "2023-08-16 13:23",
                "dep_actual": "2023-08-16 09:23",
                "dep_actual_utc": "2023-08-16 13:23",
                "arr_iata": "CLT",
                "arr_icao": "KCLT",
                "arr_terminal": null,
                "arr_gate": "D2",
                "arr_baggage": "E",
                "arr_time": "2023-08-16 11:41",
                "arr_time_utc": "2023-08-16 15:41",
                "arr_estimated": "2023-08-16 11:22",
                "arr_estimated_utc": "2023-08-16 15:22",
                "cs_airline_iata": "AA",
                "cs_flight_number": "435",
                "cs_flight_iata": "AA435",
                "status": "landed",
                "duration": 131,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692200460,
                "dep_time_ts": 1692192600,
                "arr_estimated_ts": 1692199320,
                "dep_estimated_ts": 1692192180,
                "dep_actual_ts": 1692192180
            },
            {
                "airline_iata": "AA",
                "airline_icao": "AAL",
                "flight_iata": "AA435",
                "flight_icao": "AAL435",
                "flight_number": "435",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "C",
                "dep_gate": "E9",
                "dep_time": "2023-08-16 09:30",
                "dep_time_utc": "2023-08-16 13:30",
                "dep_estimated": "2023-08-16 09:23",
                "dep_estimated_utc": "2023-08-16 13:23",
                "dep_actual": "2023-08-16 09:23",
                "dep_actual_utc": "2023-08-16 13:23",
                "arr_iata": "CLT",
                "arr_icao": "KCLT",
                "arr_terminal": null,
                "arr_gate": "D2",
                "arr_baggage": "E",
                "arr_time": "2023-08-16 11:41",
                "arr_time_utc": "2023-08-16 15:41",
                "arr_estimated": "2023-08-16 11:22",
                "arr_estimated_utc": "2023-08-16 15:22",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "landed",
                "duration": 131,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692200460,
                "dep_time_ts": 1692192600,
                "arr_estimated_ts": 1692199320,
                "dep_estimated_ts": 1692192180,
                "dep_actual_ts": 1692192180
            },
            {
                "airline_iata": "G3",
                "airline_icao": "GLO",
                "flight_iata": "G36199",
                "flight_icao": "GLO6199",
                "flight_number": "6199",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "C",
                "dep_gate": "E9",
                "dep_time": "2023-08-16 09:30",
                "dep_time_utc": "2023-08-16 13:30",
                "dep_estimated": "2023-08-16 09:23",
                "dep_estimated_utc": "2023-08-16 13:23",
                "dep_actual": "2023-08-16 09:23",
                "dep_actual_utc": "2023-08-16 13:23",
                "arr_iata": "CLT",
                "arr_icao": "KCLT",
                "arr_terminal": null,
                "arr_gate": "D2",
                "arr_baggage": "E",
                "arr_time": "2023-08-16 11:41",
                "arr_time_utc": "2023-08-16 15:41",
                "arr_estimated": "2023-08-16 11:22",
                "arr_estimated_utc": "2023-08-16 15:22",
                "cs_airline_iata": "AA",
                "cs_flight_number": "435",
                "cs_flight_iata": "AA435",
                "status": "landed",
                "duration": 131,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692200460,
                "dep_time_ts": 1692192600,
                "arr_estimated_ts": 1692199320,
                "dep_estimated_ts": 1692192180,
                "dep_actual_ts": 1692192180
            },
            {
                "airline_iata": "LA",
                "airline_icao": "LAN",
                "flight_iata": "LA6587",
                "flight_icao": "LAN6587",
                "flight_number": "6587",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "S",
                "dep_gate": "H7",
                "dep_time": "2023-08-16 09:30",
                "dep_time_utc": "2023-08-16 13:30",
                "dep_estimated": "2023-08-16 09:27",
                "dep_estimated_utc": "2023-08-16 13:27",
                "dep_actual": "2023-08-16 09:27",
                "dep_actual_utc": "2023-08-16 13:27",
                "arr_iata": "LAX",
                "arr_icao": "KLAX",
                "arr_terminal": "3",
                "arr_gate": "36",
                "arr_baggage": "21",
                "arr_time": "2023-08-16 11:54",
                "arr_time_utc": "2023-08-16 18:54",
                "arr_estimated": "2023-08-16 11:39",
                "arr_estimated_utc": "2023-08-16 18:39",
                "cs_airline_iata": "DL",
                "cs_flight_number": "739",
                "cs_flight_iata": "DL739",
                "status": "active",
                "duration": 324,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692212040,
                "dep_time_ts": 1692192600,
                "arr_estimated_ts": 1692211140,
                "dep_estimated_ts": 1692192420,
                "dep_actual_ts": 1692192420
            },
            {
                "airline_iata": "CI",
                "airline_icao": "CAL",
                "flight_iata": "CI9879",
                "flight_icao": "CAL9879",
                "flight_number": "9879",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "S",
                "dep_gate": "H7",
                "dep_time": "2023-08-16 09:30",
                "dep_time_utc": "2023-08-16 13:30",
                "dep_estimated": "2023-08-16 09:27",
                "dep_estimated_utc": "2023-08-16 13:27",
                "dep_actual": "2023-08-16 09:27",
                "dep_actual_utc": "2023-08-16 13:27",
                "arr_iata": "LAX",
                "arr_icao": "KLAX",
                "arr_terminal": "3",
                "arr_gate": "36",
                "arr_baggage": "21",
                "arr_time": "2023-08-16 11:54",
                "arr_time_utc": "2023-08-16 18:54",
                "arr_estimated": "2023-08-16 11:39",
                "arr_estimated_utc": "2023-08-16 18:39",
                "cs_airline_iata": "DL",
                "cs_flight_number": "739",
                "cs_flight_iata": "DL739",
                "status": "active",
                "duration": 324,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692212040,
                "dep_time_ts": 1692192600,
                "arr_estimated_ts": 1692211140,
                "dep_estimated_ts": 1692192420,
                "dep_actual_ts": 1692192420
            },
            {
                "airline_iata": "DL",
                "airline_icao": "DAL",
                "flight_iata": "DL739",
                "flight_icao": "DAL739",
                "flight_number": "739",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "S",
                "dep_gate": "H7",
                "dep_time": "2023-08-16 09:30",
                "dep_time_utc": "2023-08-16 13:30",
                "dep_estimated": "2023-08-16 09:27",
                "dep_estimated_utc": "2023-08-16 13:27",
                "dep_actual": "2023-08-16 09:27",
                "dep_actual_utc": "2023-08-16 13:27",
                "arr_iata": "LAX",
                "arr_icao": "KLAX",
                "arr_terminal": "3",
                "arr_gate": "36",
                "arr_baggage": "21",
                "arr_time": "2023-08-16 11:54",
                "arr_time_utc": "2023-08-16 18:54",
                "arr_estimated": "2023-08-16 11:39",
                "arr_estimated_utc": "2023-08-16 18:39",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "active",
                "duration": 324,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": "B739",
                "arr_time_ts": 1692212040,
                "dep_time_ts": 1692192600,
                "arr_estimated_ts": 1692211140,
                "dep_estimated_ts": 1692192420,
                "dep_actual_ts": 1692192420
            },
            {
                "airline_iata": "G3",
                "airline_icao": "GLO",
                "flight_iata": "G36120",
                "flight_icao": "GLO6120",
                "flight_number": "6120",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D19",
                "dep_time": "2023-08-16 09:29",
                "dep_time_utc": "2023-08-16 13:29",
                "arr_iata": "MCO",
                "arr_icao": "KMCO",
                "arr_terminal": "B",
                "arr_gate": "58",
                "arr_baggage": "25",
                "arr_time": "2023-08-16 10:38",
                "arr_time_utc": "2023-08-16 14:38",
                "arr_estimated": "2023-08-16 10:30",
                "arr_estimated_utc": "2023-08-16 14:30",
                "arr_actual": "2023-08-16 10:30",
                "arr_actual_utc": "2023-08-16 14:30",
                "cs_airline_iata": "AA",
                "cs_flight_number": "2087",
                "cs_flight_iata": "AA2087",
                "status": "landed",
                "duration": 69,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692196680,
                "dep_time_ts": 1692192540,
                "arr_estimated_ts": 1692196200,
                "arr_actual_ts": 1692196200
            },
            {
                "airline_iata": "1I",
                "airline_icao": "EJA",
                "flight_iata": "1I444",
                "flight_icao": "EJA444",
                "flight_number": "444",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": null,
                "dep_gate": null,
                "dep_time": "2023-08-16 09:24",
                "dep_time_utc": "2023-08-16 13:24",
                "dep_estimated": "2023-08-16 09:29",
                "dep_estimated_utc": "2023-08-16 13:29",
                "dep_actual": "2023-08-16 09:29",
                "dep_actual_utc": "2023-08-16 13:29",
                "arr_iata": "FXE",
                "arr_icao": "KFXE",
                "arr_terminal": null,
                "arr_gate": null,
                "arr_baggage": null,
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "landed",
                "duration": null,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": "E55P",
                "dep_time_ts": 1692192240,
                "dep_estimated_ts": 1692192540,
                "dep_actual_ts": 1692192540
            },
            {
                "airline_iata": "AA",
                "airline_icao": "AAL",
                "flight_iata": "AA2087",
                "flight_icao": "AAL2087",
                "flight_number": "2087",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D19",
                "dep_time": "2023-08-16 09:29",
                "dep_time_utc": "2023-08-16 13:29",
                "arr_iata": "MCO",
                "arr_icao": "KMCO",
                "arr_terminal": "B",
                "arr_gate": "58",
                "arr_baggage": "25",
                "arr_time": "2023-08-16 10:38",
                "arr_time_utc": "2023-08-16 14:38",
                "arr_estimated": "2023-08-16 10:30",
                "arr_estimated_utc": "2023-08-16 14:30",
                "arr_actual": "2023-08-16 10:30",
                "arr_actual_utc": "2023-08-16 14:30",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "landed",
                "duration": 69,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": "A321",
                "arr_time_ts": 1692196680,
                "dep_time_ts": 1692192540,
                "arr_estimated_ts": 1692196200,
                "arr_actual_ts": 1692196200
            },
            {
                "airline_iata": "QF",
                "airline_icao": "QFA",
                "flight_iata": "QF4157",
                "flight_icao": "QFA4157",
                "flight_number": "4157",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D19",
                "dep_time": "2023-08-16 09:29",
                "dep_time_utc": "2023-08-16 13:29",
                "arr_iata": "MCO",
                "arr_icao": "KMCO",
                "arr_terminal": "B",
                "arr_gate": "58",
                "arr_baggage": "25",
                "arr_time": "2023-08-16 10:38",
                "arr_time_utc": "2023-08-16 14:38",
                "arr_estimated": "2023-08-16 10:30",
                "arr_estimated_utc": "2023-08-16 14:30",
                "arr_actual": "2023-08-16 10:30",
                "arr_actual_utc": "2023-08-16 14:30",
                "cs_airline_iata": "AA",
                "cs_flight_number": "2087",
                "cs_flight_iata": "AA2087",
                "status": "landed",
                "duration": 69,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692196680,
                "dep_time_ts": 1692192540,
                "arr_estimated_ts": 1692196200,
                "arr_actual_ts": 1692196200
            },
            {
                "airline_iata": "BA",
                "airline_icao": "BAW",
                "flight_iata": "BA4969",
                "flight_icao": "BAW4969",
                "flight_number": "4969",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D43",
                "dep_time": "2023-08-15 17:57",
                "dep_time_utc": "2023-08-15 21:57",
                "dep_estimated": "2023-08-16 09:31",
                "dep_estimated_utc": "2023-08-16 13:31",
                "dep_actual": "2023-08-16 09:31",
                "dep_actual_utc": "2023-08-16 13:31",
                "arr_iata": "KIN",
                "arr_icao": "MKJP",
                "arr_terminal": null,
                "arr_gate": "9",
                "arr_baggage": null,
                "arr_time": "2023-08-15 18:44",
                "arr_time_utc": "2023-08-15 23:44",
                "arr_estimated": "2023-08-16 10:13",
                "arr_estimated_utc": "2023-08-16 15:13",
                "cs_airline_iata": "AA",
                "cs_flight_number": "850",
                "cs_flight_iata": "AA850",
                "status": "landed",
                "duration": 107,
                "delayed": 929,
                "dep_delayed": 934,
                "arr_delayed": 929,
                "aircraft_icao": null,
                "arr_time_ts": 1692143040,
                "dep_time_ts": 1692136620,
                "arr_estimated_ts": 1692198780,
                "dep_estimated_ts": 1692192660,
                "dep_actual_ts": 1692192660
            },
            {
                "airline_iata": "AA",
                "airline_icao": "AAL",
                "flight_iata": "AA850",
                "flight_icao": "AAL850",
                "flight_number": "850",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D43",
                "dep_time": "2023-08-15 17:57",
                "dep_time_utc": "2023-08-15 21:57",
                "dep_estimated": "2023-08-16 09:31",
                "dep_estimated_utc": "2023-08-16 13:31",
                "dep_actual": "2023-08-16 09:31",
                "dep_actual_utc": "2023-08-16 13:31",
                "arr_iata": "KIN",
                "arr_icao": "MKJP",
                "arr_terminal": null,
                "arr_gate": "9",
                "arr_baggage": null,
                "arr_time": "2023-08-15 18:44",
                "arr_time_utc": "2023-08-15 23:44",
                "arr_estimated": "2023-08-16 10:13",
                "arr_estimated_utc": "2023-08-16 15:13",
                "cs_airline_iata": null,
                "cs_flight_number": null,
                "cs_flight_iata": null,
                "status": "landed",
                "duration": 107,
                "delayed": 929,
                "dep_delayed": 934,
                "arr_delayed": 929,
                "aircraft_icao": "A319",
                "arr_time_ts": 1692143040,
                "dep_time_ts": 1692136620,
                "arr_estimated_ts": 1692198780,
                "dep_estimated_ts": 1692192660,
                "dep_actual_ts": 1692192660
            },
            {
                "airline_iata": "IB",
                "airline_icao": "IBE",
                "flight_iata": "IB4516",
                "flight_icao": "IBE4516",
                "flight_number": "4516",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D43",
                "dep_time": "2023-08-15 17:57",
                "dep_time_utc": "2023-08-15 21:57",
                "dep_estimated": "2023-08-16 09:31",
                "dep_estimated_utc": "2023-08-16 13:31",
                "dep_actual": "2023-08-16 09:31",
                "dep_actual_utc": "2023-08-16 13:31",
                "arr_iata": "KIN",
                "arr_icao": "MKJP",
                "arr_terminal": null,
                "arr_gate": "9",
                "arr_baggage": null,
                "arr_time": "2023-08-15 18:44",
                "arr_time_utc": "2023-08-15 23:44",
                "arr_estimated": "2023-08-16 10:13",
                "arr_estimated_utc": "2023-08-16 15:13",
                "cs_airline_iata": "AA",
                "cs_flight_number": "850",
                "cs_flight_iata": "AA850",
                "status": "landed",
                "duration": 107,
                "delayed": 929,
                "dep_delayed": 934,
                "arr_delayed": 929,
                "aircraft_icao": null,
                "arr_time_ts": 1692143040,
                "dep_time_ts": 1692136620,
                "arr_estimated_ts": 1692198780,
                "dep_estimated_ts": 1692192660,
                "dep_actual_ts": 1692192660
            },
            {
                "airline_iata": "G3",
                "airline_icao": "GLO",
                "flight_iata": "G36300",
                "flight_icao": "GLO6300",
                "flight_number": "6300",
                "dep_iata": "MIA",
                "dep_icao": "KMIA",
                "dep_terminal": "N",
                "dep_gate": "D60P",
                "dep_time": "2023-08-16 09:35",
                "dep_time_utc": "2023-08-16 13:35",
                "dep_estimated": "2023-08-16 09:32",
                "dep_estimated_utc": "2023-08-16 13:32",
                "dep_actual": "2023-08-16 09:32",
                "dep_actual_utc": "2023-08-16 13:32",
                "arr_iata": "MSY",
                "arr_icao": "KMSY",
                "arr_terminal": null,
                "arr_gate": "B14",
                "arr_baggage": "4",
                "arr_time": "2023-08-16 10:41",
                "arr_time_utc": "2023-08-16 15:41",
                "arr_estimated": "2023-08-16 10:39",
                "arr_estimated_utc": "2023-08-16 15:39",
                "cs_airline_iata": "MQ",
                "cs_flight_number": "3556",
                "cs_flight_iata": "MQ3556",
                "status": "active",
                "duration": 126,
                "delayed": null,
                "dep_delayed": null,
                "arr_delayed": null,
                "aircraft_icao": null,
                "arr_time_ts": 1692200460,
                "dep_time_ts": 1692192900,
                "arr_estimated_ts": 1692200340,
                "dep_estimated_ts": 1692192720,
                "dep_actual_ts": 1692192720
            }
        ]
    };
}